export default "__VITE_ASSET__b4895d7b__"